import { vtkSharedVolumeMapper } from '../vtkClasses/index.js';
import { getConfiguration } from '../../init.js';
import vtkVolumeMapper from '@kitware/vtk.js/Rendering/Core/VolumeMapper.js';
import vtkDataArray from '@kitware/vtk.js/Common/Core/DataArray.js';
import vtkBoundingBox from '@kitware/vtk.js/Common/DataModel/BoundingBox.js';
export const MAXIMUM_SAMPLES_PER_RAY = 4000;
export function sampleDistanceOf(imageData, texture, multiplier = getConfiguration().rendering?.volumeRendering
    ?.sampleDistanceMultiplier || 1) {
    const grid = texture?.getGrid?.();
    const spacing = grid?.spacing ?? imageData.getSpacing();
    const distance = (multiplier * (spacing[0] + spacing[1] + spacing[2])) / 6;
    const diagonal = vtkBoundingBox.getDiagonalLength(imageData.getBounds());
    return Math.max(distance, diagonal / (MAXIMUM_SAMPLES_PER_RAY - 1));
}
export default function createVolumeMapper(imageData, vtkOpenGLTexture) {
    const volumeMapper = vtkSharedVolumeMapper.newInstance();
    volumeMapper.setInputData(imageData);
    volumeMapper.setMaximumSamplesPerRay(MAXIMUM_SAMPLES_PER_RAY);
    volumeMapper.setSampleDistance(sampleDistanceOf(imageData, vtkOpenGLTexture));
    if (vtkOpenGLTexture) {
        volumeMapper.setScalarTexture(vtkOpenGLTexture);
    }
    return volumeMapper;
}
export function convertMapperToNotSharedMapper(sharedMapper) {
    const volumeMapper = vtkVolumeMapper.newInstance();
    volumeMapper.setBlendMode(sharedMapper.getBlendMode());
    const imageData = sharedMapper.getInputData();
    const { voxelManager } = imageData.get('voxelManager');
    const values = voxelManager.getCompleteScalarDataArray();
    const scalarArray = vtkDataArray.newInstance({
        name: `Pixels`,
        values,
    });
    imageData.getPointData().setScalars(scalarArray);
    volumeMapper.setInputData(imageData);
    volumeMapper.setMaximumSamplesPerRay(sharedMapper.getMaximumSamplesPerRay());
    volumeMapper.setSampleDistance(sharedMapper.getSampleDistance());
    return volumeMapper;
}
